import { utils } from "../../../../../shop/frontend/web/js/utils";

export class PurchaseOfferPopup {
	init() {
		$(document).on("click", ".js-show-popup-trip", e => {
			const $element = $(e.currentTarget);
			const eventId = $element.data("trip-event");
			const currentEventId = $element.data("current-event-id");

			if (!utils.getCookie(`no-show-return-trip-popup-${currentEventId}`)) {
				e.preventDefault();

				this.showPopupTrip({ eventId, currentEventId });
			}
		});

		$(document).on("click", ".js-popup-trip-close", () => {
			$("#js-return-trip-popup").hide();
			$(".modal-backdrop").hide();
		});
	}

	showPopupTrip({ eventId, currentEventId }) {
		const $popup = $("#js-return-trip-popup");
		const template = $("#js-template-popup-trip");
		const fragment = document.importNode(template[0].content, true);
		const link = $(fragment).find(".js-popup-trip-link");

		$popup.find(".modal-body").html(fragment);
		link.attr("href", `/event/?id=${eventId}`);
		utils.setCookie(`no-show-return-trip-popup-${currentEventId}`, currentEventId, {
			"max-age": 3600 * 24 * 5 + 3600 * 3,
		});
		$popup.removeClass("modal_event").addClass("modal_trip").modal();
	}
}

export const purchaseOfferPopup = new PurchaseOfferPopup();
purchaseOfferPopup.init();
